exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3y2vpFa0GNhwj3Y-wQCC1i{position:absolute;left:-9999px;z-index:9999999 !important;padding:1em;background-color:white;color:black;opacity:0;list-style:none}._3y2vpFa0GNhwj3Y-wQCC1i:focus-within{left:50%;transform:translateX(-50%);opacity:1}._3y2vpFa0GNhwj3Y-wQCC1i a{color:inherit}\n", ""]);

// exports
exports.locals = {
	"bypassblock": "_3y2vpFa0GNhwj3Y-wQCC1i"
};